var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuCircle = function SvgMenuCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.75 16.002h4.5M8.625 12.5h6.752M7.498 9h9.004m1.865-3.366a9.004 9.004 0 0 1 0 12.734 9.004 9.004 0 0 1-12.734 0 9.003 9.003 0 0 1 0-12.734 9.003 9.003 0 0 1 12.734 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuCircle);
export default ForwardRef;